import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MenuPaintedButton from './MenuPaintedButton';

export default function MenuBackButton({
  to,
  onClick,
  className = '',
  style,
  disabled = false,
  children,
  playClickSound = true,
  ...rest
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = (event) => {
    if (disabled) {
      return;
    }
    event.stopPropagation();
    if (onClick) {
      onClick(event);
      return;
    }
    if (to) {
      navigate(to, { replace: true });
      return;
    }
    throw new Error('MenuBackButton requires `onClick` or `to`');
  };

  return (
    <MenuPaintedButton
      className={`menu-back-button ${className}`.trim()}
      style={style}
      disabled={disabled}
      playClickSound={playClickSound}
      onClick={handleClick}
      leadingArrow
      {...rest}
    >
      {children ?? t('common.back')}
    </MenuPaintedButton>
  );
}
